if (typeof checkTime !== "undefined" && checkTime) {
  var detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (typeof detectedTimezone === "undefined") {
    detectedTimezone = new Date().getTimezoneOffset();
  }

  $.ajax({
    type: "POST",
    url : "/set_timezone",
    data: {
      timezone: detectedTimezone, _token: csrfToken
    }
  });
}

